import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { devices } from '../styles/viewports.styles';
import { DisplayMode } from '../views-components/DisplayMode';
import FormControl from '../views-components/FormControl';
import TextInput from '../views-components/TextInput';
import { useInputProps } from './useInputProps';
import { useSignupData } from './useSignupData';
const StyledDataInput = styled.div.withConfig({
  displayName: "SignupDataInput__StyledDataInput",
  componentId: "sc-191se8y-0"
})(["min-height:6.8rem;label{font-weight:400;font-size:16px;}@media ", "{min-height:", ";}", " ", ""], devices.desktop, props => props.isFramedCentredStep ? '6.5rem' : '7.5rem', props => props.theme.embedded && `min-height: 4.7rem;`, props => props.isFramedCentredStep && `min-height: 6.5rem;`);
export const SignupDataInput = /*#__PURE__*/forwardRef(({
  dataKey,
  disabled = false,
  displayMode = DisplayMode.Placeholder,
  customValidationError,
  renderExtraIcons,
  type,
  autoFocus = true,
  help,
  shouldShowPlaceholder = false,
  onFocus,
  onBlur
}, ref) => {
  const {
    data,
    setData
  } = useSignupData(dataKey);
  const inputProps = useInputProps(dataKey);
  const placeholder = shouldShowPlaceholder ? inputProps.placeholder : '';
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  return /*#__PURE__*/_jsx(StyledDataInput, {
    className: `SignupDataInput displayMode-${displayMode}`,
    "data-data-key": dataKey,
    isFramedCentredStep: isFramedCentredStep,
    children: /*#__PURE__*/_jsx(FormControl, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      help: help,
      children: /*#__PURE__*/_jsx(TextInput, Object.assign({
        autoFocus: autoFocus,
        disabled: disabled,
        displayMode: displayMode,
        ref: ref,
        renderExtraIcons: renderExtraIcons,
        type: type,
        value: disabled ? '' : data,
        onBlur: onBlur,
        onChange: setData,
        onFocus: onFocus
      }, inputProps, {
        placeholder: placeholder
      }))
    })
  });
});